import React from 'react';
import { CustomTextField } from '../../CustomComponents/CustomTextField';

export const Brand = ({ value = '' }) => {
  return (
    <CustomTextField disabled label="Brand" value={value} />
  );
};
